import { useState, useEffect, useCallback } from 'react'
import debounce from 'lodash/debounce'

export const useWindowSize = (delay: number = 250) => {
    const [windowSize, setWindowSize] = useState(() => ({
        width: typeof window !== 'undefined' ? window.innerWidth : 0,
        height: typeof window !== 'undefined' ? window.innerHeight : 0,
    }))

    const handleResize = useCallback(
        debounce(() => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            })
        }, delay),
        [delay],
    )

    useEffect(() => {
        if (typeof window === 'undefined') return () => {}

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [handleResize])

    return windowSize
}
